import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";

import { RootState } from "@/store/store";
import PatientsPagination from "../PatientsPagination/PatientsPagination";
import formattedDate from "@/utils/formattedDate";
import {
    setDataSelectedFormula,
    setIsSelectedDentalFormula,
} from "@/store/patients/patients";
import { setIsVisibleDentalFormulaModal } from "@/store/ui/ui";

import "./PatientDetailsPageDentalFormList.scss";

export default function PatientDetailsPageDentalFormList() {
    const dispatch = useDispatch();
    const [activepage, setActivePage] = useState<number>(1);
    const limitPage = 10;
    const startIndex = (activepage - 1) * limitPage;
    const endIndex = startIndex + limitPage;
    const dentalFormulas = useSelector(
        (state: RootState) => state.patients.dentalFormulas,
    );
    const allFormulas = Array.isArray(dentalFormulas)
        ? dentalFormulas.slice(startIndex, endIndex)
        : [];

    function handleChangeActivepage(
        event: React.ChangeEvent<unknown>,
        value: number,
    ) {
        setActivePage(value);
    }

    function handleSelectFormula(e: React.MouseEvent<HTMLTableRowElement>) {
        dispatch(setDataSelectedFormula(e.currentTarget.dataset.id));
        dispatch(setIsSelectedDentalFormula(true));
        dispatch(setIsVisibleDentalFormulaModal(true));
    }

    return (
        <section className='listing_container'>
            <table className='listing_table'>
                <thead>
                    <tr>
                        <th
                            className='listing_table-date'
                            id='listing_table_date'
                        >
                            Дата
                        </th>
                        <th
                            className='listing_table-date'
                            id='listing_table_doctor'
                        >
                            Лікар
                        </th>
                        <th className='listing_table-service'>Примітки</th>
                    </tr>
                </thead>
                <tbody>
                    {allFormulas && allFormulas.length > 0 ? (
                        allFormulas.map(item => (
                            <tr
                                key={item._id}
                                className='listing_table-row formula_row'
                                id='formula_row'
                                data-id={item._id}
                                onClick={e => handleSelectFormula(e)}
                            >
                                <td className='listing_table-date'>
                                    <p id={item._id}>
                                        {formattedDate(item.date)}
                                    </p>
                                </td>
                                <td>{item.doctorId?.name}</td>
                                <td>
                                    <div className='listing_table-notes'>
                                        {item.notes?.length > 0
                                            ? item.notes
                                            : "Примітки відсутні"}
                                    </div>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={5} className='no-data'>
                                Зубні формули відсутні
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            {allFormulas.length > 0 ? (
                <PatientsPagination
                    localdataLength={dentalFormulas?.length}
                    activepage={activepage}
                    handleChangeActivepage={handleChangeActivepage}
                    limitPage={limitPage}
                />
            ) : null}
        </section>
    );
}
